import template from './documentsList.template.html';

export default {
  template,
  bindings: {
    documents: '=',
    labels: '=',
    isCompliance: '<',
    onClick: '&',
    onEditPdf: '&',
    onPreviewPdf: '&',
    onChangeType: '&',
    onLabelsSelect: '&',
    onChange: '&',
    onPreview: '&',
    onReady: '&'
  },
  controller: class controller {
    constructor($rootScope, $filter, $mdDialog, $mdMedia, listService, DOCUMENT, FILE) {
      'ngInject';

      const ctrl = this;
      ctrl.currentTimeZone = null;
      ctrl.currentDateFormat = null;
      ctrl.$mdMedia = $mdMedia;
      ctrl.natural = $rootScope.natural;
      ctrl.list = listService;
      ctrl.list.clear();
      ctrl.types = _.sortBy(DOCUMENT.TYPES, 'value');

      ctrl.initialize = () => {
        ctrl.currentOrganization = $rootScope.CurrentOrganization;
        ctrl.currentTimeZone = $rootScope.CurrentTimeZone();
        ctrl.currentLocale = $rootScope.CurrentLocale();
        ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
        ctrl.acceptableFileExtensions = FILE.ACCEPTABLE_FILE_EXTENSIONS;
        ctrl.list.setData(
          $filter('stStartingLetter')(ctrl.documents, ctrl.list.getGroupingByFirstLetter())
        );
        ctrl.onReady({ list: ctrl.list });
      };

      ctrl.click = ($event, data) => {
        ctrl.onClick({ event: $event, data });
      };

      ctrl.editPdf = ($event, data) => {
        ctrl.onEditPdf({ event: $event, data });
      };

      ctrl.previewPdf = ($event, data) => {
        ctrl.onPreviewPdf({ event: $event, data });
      };

      ctrl.preview = ($event, data) => {
        ctrl.onPreview({ event: $event, data });
      };

      ctrl.select = (data) => {
        const isSelected = ctrl.list.setSelected(data);
        ctrl.onChange({ list: ctrl.list, data, isSelected });
      };

      ctrl.labelsSelect = ($event, data) => {
        ctrl.onLabelsSelect({ event: $event, data });
      };

      ctrl.canOpenPreview = () =>
        _.indexOf(
          ctrl.acceptableFileExtensions || [],
          ctrl.attachment?.getFileExtension()?.toLowerCase()
        ) > -1;

      ctrl.getLabel = (idLabel) => _.find(ctrl.labels, (label) => label.id === idLabel);

      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      ctrl.$onChanges = (changes) => {
        if (changes.documents && changes.documents.currentValue) {
          ctrl.initialize();
        }
      };
    }
  }
};
